import request from "../request";
import { stringify } from "qs";

export function getArticleTypeList(payload) {
	return request.get({
		url: `/website/websiteArticle/articleTypeList`,
	});
}

export function getNewsList(payload) {
	return request.post({
		url: "/website/websiteArticle/newsList",
		headers: { "Content-Type": "application/json" },
		data: JSON.stringify(payload),
	});
}

export function getWebsiteArticleById(payload) {
	return request.get({
		url: `/website/websiteArticle/getById?${stringify(payload)}`,
	});
}

export function getHotList(payload) {
	return request.get({
		url: `/website/websiteArticle/getHotList`,
	});
}
